
<div class="w-100">
    <v-expansion-panels
        v-model = "year"
        class   = "pa-1"
        accordion
        flat
    >
        <v-expansion-panel
            class = "mt-0 mb-1"
            :key  = "yearList.year"
            v-for = "yearList in maintenanceList"
        >
            <v-expansion-panel-header
                color       = "primary"
                class       = "ml-0 pr-0"
                expand-icon = "mdi-menu-down"
            >
                <div class="v-flex white--text">
                    <div>
                        {{ yearList.year }}
                    </div>
                    <v-spacer />
                    <div>
                        {{ yearList.entries.length }} x
                    </div>
                </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content
                class="white"
            >
                <v-list
                    class="pt-0 pb-0 mt-1"
                >
                    <v-list-item
                        class  = "pl-0 ml-0"
                        :class = "background(maintenence)"
                        @click = "onSelected(maintenence)"
                        :ripple = "false"
                        v-for  = "(maintenence, index) in yearList.entries" :key="yearList.year + '-' + index"
                        link
                    >
                        <v-list-item-title class="v-flex pl-2" >
                            {{ format(maintenence.executiondate)}}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</div>
